"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOnVirtualGamePage = exports.isResponseFromVirtualGames = void 0;
const constants_1 = require("../virtual-games/constants");
const isResponseFromVirtualGames = (url) => {
    if (url !== undefined) {
        return constants_1.VIRTUAL_GAMES_ENDPOINTS.some((endpoint) => url.endsWith(endpoint));
    }
    return false;
};
exports.isResponseFromVirtualGames = isResponseFromVirtualGames;
const isOnVirtualGamePage = (path, virtualGamesRoutes) => {
    return Array.from(virtualGamesRoutes).some((route) => route !== '' && path.startsWith(route));
};
exports.isOnVirtualGamePage = isOnVirtualGamePage;
//# sourceMappingURL=virtual-games.js.map